module.exports = __webpack_public_path__ + "01_very_short_brown.80fbf54d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_very_short_brown.png
// module id = SA/5
// module chunks = 0